module.exports = __webpack_public_path__ + "static/media/image-item.ab8b1c88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dummy_images/image-item.jpg
// module id = 1121
// module chunks = 0